<!--
 * @Description  : 分类详情弹框
 * @Author       : wuxuebing
 * @Date         : 2024-09-26 14:21:16
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-28 10:59:27
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-management\components\sort-dialog.vue
-->
<template>
  <el-dialog
    :title="dialogObj.title"
    width="800px"
    :visible.sync="dialogObj.visible"
    @close="handleClose"
    :destroy-on-close="true"
    :close-on-click-modal="false"
  >
    <template v-if="dialogObj.visible">
      <!-- 已选分类表格 -->
      <vxe-table
        border
        resizable
        class="mt10 Ltable mb20"
        show-overflow
        ref="tableData"
        max-height="450px"
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        show-header-overflow="tooltip"
      >
        <vxe-column
          type="seq"
          width="60"
          align="center"
          title="序号"
        ></vxe-column>
        <vxe-column field="sname" title="所属类型" min-width="100">
        </vxe-column>
      </vxe-table>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogObj: {
        //弹出框对象
        visible: false,
        title: "查看所属分类",
        mode: ""
      },
      tableData: [] // 所属分类表格
    };
  },
  methods: {
    // 弹框初始化
    initDialog(data) {
      this.tableData = data.type;
      this.dialogObj.visible = true;
    },

    //关闭后的回调
    handleClose() {
      // 重置所有数据
      this.tableData = [];
      this.dialogObj.visible = false;
    }
  },
  computed: {}
};
</script>

<style lang="less" scoped>
/deep/.el-dialog .el-dialog__body {
  max-height: 500px;
  overflow: scroll;
  overflow-x: hidden;
}
</style>
